module.exports = __webpack_public_path__ + "static/img/real4.343255a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/demo/real4.jpg
// module id = jvjy
// module chunks = 1